// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';

import BoomBasketSwitchContainer from '../../modules/boom/components/BoomBasketSwitch/BoomBasketSwitchContainer';
import GRBasketSwitchContainer from '../../modules/gift-race/containers/GRBasketSwitchContainer';
import KLBasketSwitchContainer from '../../modules/koh-lanta/containers/KLBasketSwitchContainer';
import MissionBasketSwitchContainer from '../../modules/missions/components/MissionBasketSwitch/MissionBasketSwitchContainer';
import MPBasketSwitchContainer from '../../modules/monopoly/containers/MPBasketSwitchContainer';
import { BasketRow } from '../../styled-components/shared';
import { BasketItemStatuses, type BasketItemStatus } from '../../types/basket';
import type { OddsChange } from '../../types/basket';
import type { BasketMode } from '../../types/basket';
import BasketFreebetsSwitchContainer from '../BasketFreebetsSwitch/BasketFreebetsSwitchContainer';
import BasketOdds from '../BasketOdds';

const StyledCardOdds = styled(BasketOdds)`
  width: 100%;
  line-height: 0.9;
  margin-top: -0.4em;
  pointer-events: none;
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: relative;

  margin-top: 0.5em;
`;

const switchesSharedStyle = css`
  width: 100%;
`;

const StyledKLBasketSwitchContainer = styled(KLBasketSwitchContainer)`
  ${switchesSharedStyle}
`;

const StyledGRBasketSwitchContainer = styled(GRBasketSwitchContainer)`
  ${switchesSharedStyle}
`;

const StyledMissionBasketSwitchContainer = styled(MissionBasketSwitchContainer)`
  ${switchesSharedStyle}
`;

const StyledMPBasketSwitchContainer = styled(MPBasketSwitchContainer)`
  ${switchesSharedStyle}
`;

const StyledBoomBasketSwitchContainer = styled(BoomBasketSwitchContainer)`
  ${switchesSharedStyle}
`;

const FreebetSwitchContainer = styled(BasketFreebetsSwitchContainer)`
  ${switchesSharedStyle}
`;

type BasketCardOddsProps = {
  basketMode: BasketMode;
  status: BasketItemStatus;
  validatedValue?: number;
  value: number;
  changed?: OddsChange;
  oddId: number;
};

const BasketCardOdds = ({ basketMode, status, validatedValue, value, changed, oddId }: BasketCardOddsProps) => {
  const isValidatedOddsChanged =
    (status === BasketItemStatuses.VALIDATED || status === BasketItemStatuses.PENDING) &&
    !!validatedValue &&
    value !== validatedValue;

  return (
    <Column>
      <BasketRow>
        <StyledGRBasketSwitchContainer oddsId={oddId} />
      </BasketRow>
      <BasketRow>
        <StyledKLBasketSwitchContainer oddsId={oddId} />
      </BasketRow>
      <BasketRow>
        <StyledMissionBasketSwitchContainer oddsId={oddId} />
      </BasketRow>
      <BasketRow>
        <StyledMPBasketSwitchContainer oddsId={oddId} />
      </BasketRow>
      <BasketRow>
        <StyledBoomBasketSwitchContainer oddsId={oddId} />
      </BasketRow>
      <BasketRow>
        <FreebetSwitchContainer itemId={oddId} />
      </BasketRow>
      <StyledCardOdds
        validatedValue={isValidatedOddsChanged ? validatedValue : null}
        value={value}
        changed={changed}
        $basketMode={basketMode}
      />
    </Column>
  );
};

export default React.memo<BasketCardOddsProps>(BasketCardOdds);
